import React from "react";
import { Link, useLocation } from "react-router-dom";
import {basicMonthlyAmount,advancedMonthlyAmount,basicYearlyAmount,advancedYearlyAmount,
  basicWeekAmount,advancedWeekAmount} from '../../../utils/publicPlanPrices';

const Footer = () => {
  const {pathname}=useLocation();
  const showDisclosures=!pathname.startsWith('/cabinet');
  return (
  <section className="footerSec">
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div className="copyTxt">
              <p>© 2026 DeepTrading.ai, All Rights Reserved</p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <div className="termLinks">
              <Link to="/policy">Privacy Policy</Link>
              &nbsp;|&nbsp;
              <Link to="/terms">Terms of Use</Link>
              &nbsp;|&nbsp;
              <Link to="/account-deletion">Account Deletion</Link>
            </div>
          </div>
        </div>
        {showDisclosures && <div className="row footerDisclosures">
          <div className="col-12">
            <p>Nektron, Inc. · 99 Prospect Ave., Bayonne, New Jersey 07002, USA · <a href="mailto:info@deeptrading.ai">info@deeptrading.ai</a></p>
            <p>USD subscription prices: Basic ${basicMonthlyAmount}/month or ${basicYearlyAmount}/year;
              Advanced ${advancedMonthlyAmount}/month or ${advancedYearlyAmount}/year.
              One-week passes: Basic ${basicWeekAmount}, Advanced ${advancedWeekAmount}.</p>
            <p>For research and educational use. Predictions and backtests do not guarantee future results.
              Investing involves risk, including loss of principal. DeepTrading.ai does not execute trades.</p>
          </div>
        </div>}
      </div>
    </footer>
  </section>
  );
};

export default Footer;
